import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { Text } from '../../../components/ui/typography/Text';

interface ResultsGraphProps {
  studyData: Array<{
    name: string;
    value: number;
    fill: string;
  }>;
}

// Custom tooltip component for cleaner presentation
const CustomTooltip = ({ active, payload, label }: any) => {
  // Only show tooltip on larger screens
  if (typeof window !== 'undefined' && window.innerWidth < 640 || !active || !payload || payload.length === 0) return null;
  
  return (
    <div className="bg-white p-3 rounded-lg border border-gray-200 shadow-sm text-sm">
      <p className="font-medium mb-1">{label}</p>
      <p className="text-orange-500">
        {payload[0].value}% of participants selected this card
      </p>
    </div>
  );
};

export const ResultsGraph: React.FC<ResultsGraphProps> = ({ studyData }) => {
  return (
    <div className="flex flex-col h-full w-full overflow-x-auto">
      {/* Chart area - give it more height */}
      <div className="flex-1 min-w-[400px]" style={{ height: "85%" }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart 
            data={studyData} 
            margin={{ 
              top: 20,
              right: 30,
              left: 30,  // Increased left margin for y-axis label
              bottom: 30
            }}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
            <XAxis 
              dataKey="name"
              tick={{ fill: '#4B5563' }}
            />
            <YAxis 
              label={{ 
                value: 'Percentage of participants', 
                angle: -90, 
                position: 'insideLeft',
                offset: 0,
                dx: -20,  // Moved label further left
                style: {
                  textAnchor: 'middle',
                  fontSize: '0.875rem',
                  fill: '#4B5563'
                }
              }} 
              domain={[0, 100]}
              ticks={[0, 25, 50, 75, 100]}
              tick={{ fill: '#4B5563' }}
            />
            <Tooltip content={<CustomTooltip />} />
            <Bar 
              dataKey="value" 
              fill="#f97316" 
              radius={[4, 4, 0, 0]}
              label={{ 
                position: 'top', 
                formatter: (value: number) => `${value}%`,
                fill: '#f97316',
                fontSize: 12,
                fontWeight: 500
              }}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>

      {/* Legend - centered and reduced gap */}
      <div className="mt-2 text-center mx-auto" style={{ height: "15%" }}>
        <Text className="text-xs text-gray-500 italic">
          Data from Wason's 1966 selection task study (n=128)
        </Text>
      </div>
    </div>
  );
}; 